import Logo from "@/components/Logo";

const PageLoader = () => {
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4 animate-fade-in">
        <div className="relative">
          <div className="w-16 h-16 animate-pulse">
            <Logo size="xl" showText={false} />
          </div>
          <div className="absolute -inset-2 bg-gradient-hero rounded-2xl opacity-20 animate-ping"></div>
        </div>
        
        <div className="flex flex-col items-center gap-2">
          <span className="text-lg font-semibold bg-gradient-hero bg-clip-text text-transparent">
            SKECHA
          </span>
          <div className="flex gap-1">
            <div className="w-2 h-2 bg-primary rounded-full animate-[bounce_1s_ease-in-out_infinite]"></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-[bounce_1s_ease-in-out_infinite_0.1s]"></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-[bounce_1s_ease-in-out_infinite_0.2s]"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;